import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '../icons/google-material-icon/google-material-icon';
import { BECOME_A_MEMBER } from '@/utils/constants';

@Component({
    name: 'guest-user-pop',
    components: {
        'materail-icons': GoogleMaterialIcon,
    },
})

export default class GuestUserPop extends Vue {

    // ---------------------------------------------------------------------------------
    // Properties

    // ---------------------------------------------------------------------------------
    // Hooks

    // ----------------------------------------------------------------------------------
    // Actions

    private onSignUp() {
       window.open(BECOME_A_MEMBER);
    }

    private onClosePop() {
        this.$emit('onClosePop');
    }

    // ---------------------------------------------------------------------------------
    // Methods

}
